module.exports = __webpack_public_path__ + "img/img1.c95276d2.png";